export const nullRender = () => null;
